import {useState} from "react";
import {Consts} from "../../pages/consts";
import {useTranslation} from "react-i18next";
import {isOnlyNumber} from "../../pages/utils";
import {genotypesToSelect} from "../../../resources/json/jsons";

const AlleleSelector = ({
                          alleleNumber,
                          selectedValue,
                          isCustom,
                          customValue,
                          handleSelectChange,
                          handleInputChange,
                          genotypeOptions,
                          t
                        }) => (
  <div className="container">
    <label style={ {width: '30%'} }>{ t("allele") } { alleleNumber }</label>
    <select
      value={ selectedValue }
      onChange={ (e) => handleSelectChange(e, alleleNumber) }
      className="select_box_style"
      style={ {width: '30%'} }
    >
      { genotypeOptions?.map((option, index) => (
        <option key={ `${ alleleNumber }-${ index }` } value={ option }>
          { option }
        </option>
      )) }
    </select>
    { isCustom && (
      <input
        type={ Consts.TEXT }
        placeholder={ t("or_enter_manually") }
        value={ customValue }
        onChange={ (e) => handleInputChange(e, alleleNumber) }
        className="select_box_style"
        style={ {width: '30%'} }
      />
    ) }
  </div>
);

const SelectWithInput = ({setAllele1, setAllele2}) => {
  const [selectedValue1, setSelectedValue1] = useState("");
  const [selectedValue2, setSelectedValue2] = useState("");
  const [customValue1, setCustomValue1] = useState("");
  const [customValue2, setCustomValue2] = useState("");
  const [isCustom1, setIsCustom1] = useState(false);
  const [isCustom2, setIsCustom2] = useState(false);
  const {t} = useTranslation();

  const getStateSetter = (alleleNumber, setters) => {
    return alleleNumber === 1 ? setters[0] : setters[1];
  };

  const handleSelectChange = (e, alleleNumber) => {
    const value = e.target.value;
    const isNumber = isOnlyNumber(value);
    getStateSetter(alleleNumber, [setAllele1, setAllele2])(value);
    getStateSetter(alleleNumber, [setIsCustom1, setIsCustom2])(!isNumber && value !== "4A/B" && value !== "1173C>T" && value !== "XN");

    if (isNumber || value === "4A/B" || value === "1173C>T" || value === "XN") {
      getStateSetter(alleleNumber, [setCustomValue1, setCustomValue2])("");
      getStateSetter(alleleNumber, [setSelectedValue1, setSelectedValue2])(value);
    }
  };

  const handleInputChange = (e, alleleNumber) => {
    const value = e.target.value;
    getStateSetter(alleleNumber, [setAllele1, setAllele2])(value);
    getStateSetter(alleleNumber, [setCustomValue1, setCustomValue2])(value);
  };

  /*let genotypeOptions = Array.from({ length: 50 }, (_, i) =>
    (i + 1).toString(),
  );

  genotypeOptions = [...genotypeOptions, t(Consts.OTHER)?.toLowerCase()];
  */

  const genotypeOptions = [...genotypesToSelect, t(Consts.OTHER)?.toLowerCase()];

  return (
    <>
      <AlleleSelector
        alleleNumber={ 1 }
        selectedValue={ selectedValue1 }
        isCustom={ isCustom1 }
        customValue={ customValue1 }
        handleSelectChange={ handleSelectChange }
        handleInputChange={ handleInputChange }
        genotypeOptions={ genotypeOptions }
        t={ t }
      />
      <AlleleSelector
        alleleNumber={ 2 }
        selectedValue={ selectedValue2 }
        isCustom={ isCustom2 }
        customValue={ customValue2 }
        handleSelectChange={ handleSelectChange }
        handleInputChange={ handleInputChange }
        genotypeOptions={ genotypeOptions }
        t={ t }
      />
    </>
  );
};

export default SelectWithInput;
